import React from "react";
import { useSearchParams } from "react-router-dom";

import BaseCheckbox from "components/Shared/Base/BaseCheckbox";

import { useAuth, useGetUrlParams } from "hooks";

import { camelCasefy } from "utils/stringHelpers";

const FilterMine = ({ filterMineKey, ...props }) => {
  const URL_PARAMS = useGetUrlParams();

  const [searchParams, setSearchParams] = useSearchParams();

  const { loggedInUser } = useAuth();

  const filterMineRef = searchParams.get(camelCasefy(filterMineKey)) || null;

  const filterMine = filterMineRef === loggedInUser?._id;

  // methods
  const handleToggleShowMine = () => {
    if (filterMineKey && !filterMine)
      return setSearchParams({
        ...URL_PARAMS,
        [camelCasefy(filterMineKey)]: loggedInUser?._id,
      });

    delete URL_PARAMS[camelCasefy(filterMineKey)];

    setSearchParams(URL_PARAMS);
  };

  return (
    <BaseCheckbox
      label="Filter Mine"
      checked={filterMine}
      onChange={handleToggleShowMine}
      {...props}
    />
  );
};

export default FilterMine;
